import { Badge } from "@/components/Badge.tsx";
import { Trans } from "@lingui/react/macro";
import type {
    KubernetesReadynessTypeEnum,
    KubernetesStatusConditions,
    ManagedKubernetesService,
} from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";

type SupportedReadynessTypes = "APIServerAvailable" | "EveryNodeReady" | "SystemComponentsHealthy";

type DesiredReadynessTypes = Pick<Record<KubernetesReadynessTypeEnum, ReactNode>, SupportedReadynessTypes>;

const readynessTypeMap = {
    APIServerAvailable: <Trans>API</Trans>,
    EveryNodeReady: <Trans>nodes</Trans>,
    SystemComponentsHealthy: <Trans>system</Trans>,
} satisfies DesiredReadynessTypes;

export function KubernetesReadynessBadge({ item }: { item: ManagedKubernetesService }) {
    const { properties } = item;

    return properties?.status?.conditions.map((o: KubernetesStatusConditions, idx: number) => {
        if (!isSupportedType(o.type)) {
            return null;
        }
        return (
            <Badge
                key={idx}
                className="uppercase"
                color={o.reason === "ConditionNotChecked" ? "default" : o.status === "True" ? "success" : "error"}
            >
                {readynessTypeMap[o.type]}
            </Badge>
        );
    });
}

function isSupportedType(type: KubernetesReadynessTypeEnum): type is SupportedReadynessTypes {
    return type in readynessTypeMap;
}

// cspell:words Readyness
